module.exports = __webpack_public_path__ + "static/media/blurred.5b9088de.png";